import { env } from '@/config'

let sdkPromise = null
let initialized = false

function loadSdk() {
    if (!sdkPromise) {
        sdkPromise = import(/* webpackChunkName: "lucra-sdk" */ 'lucra-web-sdk/dist/index.js')
    }
    return sdkPromise
}

export async function getLucraSdk() {
    return loadSdk()
}

export async function getLucraClient() {
    const { LucraClient } = await loadSdk()
    if (!initialized) {
        LucraClient.initialize({
            apiKey: env.LUCRA_WEB_KEY,
            tenantId: env.LUCRA_TENANT_ID,
            env: env.LUCRA_ENV || 'sandbox',
        })
        initialized = true
    }
    return LucraClient.getInstance()
}

export async function destroyLucraClient() {
    if (!initialized) {
        return
    }
    const { LucraClient } = await loadSdk()
    const client = LucraClient.getInstance()
    if (client && client.isInitialized) {
        try {
            // Tearing down our own client only drops our reference to the iframe. Lucra
            // still remembers this browser as signed in (its own session cookie), so the
            // next ShiftOS user to open it would silently inherit the previous person's
            // Lucra account. Log Lucra itself out first so a fresh phone login is required.
            client.logout()
            await new Promise((resolve) => setTimeout(resolve, 400))
        } catch (e) {
            // Best effort, still tear down our own client below.
        }
    }
    LucraClient.destroy()
    initialized = false
}
